import React, {Component} from "react";
import {
	Grid,
	Backdrop,
	Container,
	IconButton,
	CircularProgress
} from "@mui/material";
import {
	withStyles
} from "@mui/styles";
import {
	Autorenew as AutorenewIcon
} from "@mui/icons-material";
import {
	NumberCard
} from "./components";
import {
	notification,
	notificationTypes
} from "../../../utils/notification";
import agent from "../../../agent/agent";
import getTrans from "../../../languages/getTrans";

class NumbersReceived extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isBackdrop: false,
			dateTimeLastUpdate: null
		};
		this.timeoutCheckUpdate = null;
	}

	componentDidMount = async () => {
		await this.props.getReceivedNumbers();
		await this.watchUpdateGetNumbers();
	}
	componentWillUnmount = () => {
		clearTimeout(this.timeoutCheckUpdate);
	}
	watchUpdateGetNumbers = async () => {
		clearTimeout(this.timeoutCheckUpdate);

		const { user } = this.props;
		const { dateTimeLastUpdate } = this.state;
		const apiKey = user?.settings?.apiKey;
		const apiHost = String(process.env.REACT_APP_HOST_API || '').replace('https://', 'https://api.');

		const _dateTimeLastUpdate = await agent.get([apiHost, '/sms/phone-number/lastupdate?api_key=', apiKey].join('')).then((res) => {
			const _data = res.data;
			return Boolean(_data?.status === 200) ? _data?.data || null : null
		}).catch(() => {
			return null
		});
		if (_dateTimeLastUpdate !== dateTimeLastUpdate && dateTimeLastUpdate && _dateTimeLastUpdate) {
			await this.props.getReceivedNumbers();
		}

		await this.setState({
			dateTimeLastUpdate: _dateTimeLastUpdate
		})
		this.timeoutCheckUpdate = setTimeout(async () => {
			await this.watchUpdateGetNumbers();
		}, (10 * 1000));
	}

	cancelNumber = async (item) => {
		await this.setState({ isBackdrop: true });
		const isSuccess = await agent.put(`/api/sms-users/cancel-number/${ item.id }`).then((res) => {
			return Boolean(res?.data === 'ACCESS_CANCEL')
		}).catch(() => false);
		if (!isSuccess) {
			await this.setState({ isBackdrop: false });
			notification({
				type: notificationTypes.error,
				message: getTrans('numbersReceived.При отмена номера произошла ошибка, возможно номер уже отменен.')
			})
			return
		}
		await new Promise(r => setTimeout(r, 1000));
		await this.props.getReceivedNumbers({isClearCache: true});
		await this.setState({ isBackdrop: false });
		notification({
			type: notificationTypes.success,
			message: getTrans('numbersReceived.Номер успешно отменен')
		})
	}
	repeatNumber = async (item) => {
		await this.setState({ isBackdrop: true });
		const apiUrl = [
			`/api/sms-users/get-number/${ item?.country_code }/${ item?.service_code }`,
			Boolean(item?.price) && `maxPrice=${ item?.price }`
		].filter((t) => !!t).join('?');
		const res = await agent.get(apiUrl).then((res) => {
				return res?.data
			}).catch((err) => {
				return {error: err?.response?.data?.message || getTrans('errors.Ошибка сервера')}
			});
		if (res?.error) {
			await this.setState({ isBackdrop: false });
			notification({
				message: res?.error,
				type: notificationTypes.error,
			})
			return
		}
		await new Promise(r => setTimeout(r, 1000));
		await this.props.getReceivedNumbers({isClearCache: true});
		await this.setState({ isBackdrop: false });
		notification({
			type: notificationTypes.success,
			message: getTrans('home.Номер успешно приобретен')
		})
	};

	render() {
		const {
			classes,
			isLoading,
			receivedNumbers,
			getReceivedNumbers
		} = this.props;
		const {
			isBackdrop
		} = this.state;

		return (
			<>
				<div className={classes.head}>
					<div className={classes.headIcon}>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M7.875 4.5C7.875 4.87084 7.76503 5.23335 7.55901 5.54169C7.35298 5.85004 7.06014 6.09036 6.71753 6.23227C6.37492 6.37419 5.99792 6.41132 5.63421 6.33897C5.27049 6.26663 4.9364 6.08805 4.67418 5.82583C4.41195 5.5636 4.23338 5.22951 4.16103 4.8658C4.08868 4.50208 4.12581 4.12508 4.26773 3.78247C4.40964 3.43986 4.64996 3.14702 4.95831 2.941C5.26665 2.73497 5.62916 2.625 6 2.625C6.49728 2.625 6.9742 2.82254 7.32583 3.17418C7.67746 3.52581 7.875 4.00272 7.875 4.5ZM12 2.625C11.6292 2.625 11.2666 2.73497 10.9583 2.941C10.65 3.14702 10.4096 3.43986 10.2677 3.78247C10.1258 4.12508 10.0887 4.50208 10.161 4.8658C10.2334 5.22951 10.412 5.5636 10.6742 5.82583C10.9364 6.08805 11.2705 6.26663 11.6342 6.33897C11.9979 6.41132 12.3749 6.37419 12.7175 6.23227C13.0601 6.09036 13.353 5.85004 13.559 5.54169C13.765 5.23335 13.875 4.87084 13.875 4.5C13.875 4.00272 13.6775 3.52581 13.3258 3.17418C12.9742 2.82254 12.4973 2.625 12 2.625ZM18 6.375C18.3708 6.375 18.7334 6.26503 19.0417 6.05901C19.35 5.85298 19.5904 5.56014 19.7323 5.21753C19.8742 4.87492 19.9113 4.49792 19.839 4.13421C19.7666 3.77049 19.588 3.4364 19.3258 3.17418C19.0636 2.91195 18.7295 2.73338 18.3658 2.66103C18.0021 2.58868 17.6251 2.62581 17.2825 2.76773C16.9399 2.90964 16.647 3.14996 16.441 3.45831C16.235 3.76665 16.125 4.12916 16.125 4.5C16.125 4.99728 16.3225 5.4742 16.6742 5.82583C17.0258 6.17746 17.5027 6.375 18 6.375ZM6 7.875C5.62916 7.875 5.26665 7.98497 4.95831 8.19099C4.64996 8.39702 4.40964 8.68986 4.26773 9.03247C4.12581 9.37508 4.08868 9.75208 4.16103 10.1158C4.23338 10.4795 4.41195 10.8136 4.67418 11.0758C4.9364 11.338 5.27049 11.5166 5.63421 11.589C5.99792 11.6613 6.37492 11.6242 6.71753 11.4823C7.06014 11.3404 7.35298 11.1 7.55901 10.7917C7.76503 10.4834 7.875 10.1208 7.875 9.75C7.875 9.25272 7.67746 8.77581 7.32583 8.42418C6.9742 8.07254 6.49728 7.875 6 7.875ZM12 7.875C11.6292 7.875 11.2666 7.98497 10.9583 8.19099C10.65 8.39702 10.4096 8.68986 10.2677 9.03247C10.1258 9.37508 10.0887 9.75208 10.161 10.1158C10.2334 10.4795 10.412 10.8136 10.6742 11.0758C10.9364 11.338 11.2705 11.5166 11.6342 11.589C11.9979 11.6613 12.3749 11.6242 12.7175 11.4823C13.0601 11.3404 13.353 11.1 13.559 10.7917C13.765 10.4834 13.875 10.1208 13.875 9.75C13.875 9.25272 13.6775 8.77581 13.3258 8.42418C12.9742 8.07254 12.4973 7.875 12 7.875ZM18 7.875C17.6292 7.875 17.2666 7.98497 16.9583 8.19099C16.65 8.39702 16.4096 8.68986 16.2677 9.03247C16.1258 9.37508 16.0887 9.75208 16.161 10.1158C16.2334 10.4795 16.412 10.8136 16.6742 11.0758C16.9364 11.338 17.2705 11.5166 17.6342 11.589C17.9979 11.6613 18.3749 11.6242 18.7175 11.4823C19.0601 11.3404 19.353 11.1 19.559 10.7917C19.765 10.4834 19.875 10.1208 19.875 9.75C19.875 9.25272 19.6775 8.77581 19.3258 8.42418C18.9742 8.07254 18.4973 7.875 18 7.875ZM6 13.125C5.62916 13.125 5.26665 13.235 4.95831 13.441C4.64996 13.647 4.40964 13.9399 4.26773 14.2825C4.12581 14.6251 4.08868 15.0021 4.16103 15.3658C4.23338 15.7295 4.41195 16.0636 4.67418 16.3258C4.9364 16.588 5.27049 16.7666 5.63421 16.839C5.99792 16.9113 6.37492 16.8742 6.71753 16.7323C7.06014 16.5904 7.35298 16.35 7.55901 16.0417C7.76503 15.7334 7.875 15.3708 7.875 15C7.875 14.5027 7.67746 14.0258 7.32583 13.6742C6.9742 13.3225 6.49728 13.125 6 13.125ZM12 13.125C11.6292 13.125 11.2666 13.235 10.9583 13.441C10.65 13.647 10.4096 13.9399 10.2677 14.2825C10.1258 14.6251 10.0887 15.0021 10.161 15.3658C10.2334 15.7295 10.412 16.0636 10.6742 16.3258C10.9364 16.588 11.2705 16.7666 11.6342 16.839C11.9979 16.9113 12.3749 16.8742 12.7175 16.7323C13.0601 16.5904 13.353 16.35 13.559 16.0417C13.765 15.7334 13.875 15.3708 13.875 15C13.875 14.5027 13.6775 14.0258 13.3258 13.6742C12.9742 13.3225 12.4973 13.125 12 13.125ZM12 18.375C11.6292 18.375 11.2666 18.485 10.9583 18.691C10.65 18.897 10.4096 19.1899 10.2677 19.5325C10.1258 19.8751 10.0887 20.2521 10.161 20.6158C10.2334 20.9795 10.412 21.3136 10.6742 21.5758C10.9364 21.838 11.2705 22.0166 11.6342 22.089C11.9979 22.1613 12.3749 22.1242 12.7175 21.9823C13.0601 21.8404 13.353 21.6 13.559 21.2917C13.765 20.9834 13.875 20.6208 13.875 20.25C13.875 19.7527 13.6775 19.2758 13.3258 18.9242C12.9742 18.5725 12.4973 18.375 12 18.375ZM18 13.125C17.6292 13.125 17.2666 13.235 16.9583 13.441C16.65 13.647 16.4096 13.9399 16.2677 14.2825C16.1258 14.6251 16.0887 15.0021 16.161 15.3658C16.2334 15.7295 16.412 16.0636 16.6742 16.3258C16.9364 16.588 17.2705 16.7666 17.6342 16.839C17.9979 16.9113 18.3749 16.8742 18.7175 16.7323C19.0601 16.5904 19.353 16.35 19.559 16.0417C19.765 15.7334 19.875 15.3708 19.875 15C19.875 14.5027 19.6775 14.0258 19.3258 13.6742C18.9742 13.3225 18.4973 13.125 18 13.125Z" fill="#FB7800"/>
						</svg>
					</div>
					<div className={classes.headTitle}>{getTrans('numbersReceived.Полученные номера')}</div>
					<IconButton className={classes.headButton} onClick={getReceivedNumbers} disabled={isLoading}>
						<AutorenewIcon/>
					</IconButton>
				</div>
				<Container sx={{height: "calc(100vh)", overflow: "auto", padding: "0", marginBottom: "-78px", paddingBottom: "78px"}}>
					<Grid container spacing={1}>
						{receivedNumbers.map((item) => (
							<Grid key={`${item.id}-${item.status}-${(item.multiple_codes || []).join('_')}-${item.code}`} item xs={12}>
								<NumberCard
									item={item}
									onRepeat={this.repeatNumber.bind(this, item)}
									onCancel={this.cancelNumber.bind(this, item)}
								/>
							</Grid>
						))}
					</Grid>
				</Container>
				<Backdrop open={isBackdrop}>
					<CircularProgress/>
				</Backdrop>
			</>
		);
	}
}

const styles = theme => ({
	head: {
		gap: "8px",
		display: "flex",
		padding: "0 8px",
		alignItems: "center",
		paddingBottom: "12px",
		boxSizing: "border-box",
	},
	headIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: 24, height: 24,
	},
	headTitle: {
		fontSize: 18,
		fontWeight: "600",
		lineHeight: "24px",
		letterSpacing: "0.03em",
		color: theme.palette.text.primary,
	},
	headButton: {
		padding: 0,
		marginLeft: 'auto',
		"& svg": {
			color: "white"
		}
	}
});
NumbersReceived = withStyles(styles, { withTheme: true })(NumbersReceived);

export default NumbersReceived
